import UserIcon from "@mui/icons-material/Person";
import { AccountServicePath, USERS } from "utils/constants";

import permissions from "app/permissions";
import { resources as Students } from "./Students";
import { resources as Candidates } from "./Candidates";
import { resources as ParticipantsPreparatory } from "./ParticipantsPreparatory";
import { resources as Specialists } from "./Specialists";
import { resources as Doctorants } from "components/Doctoral/Doctorants";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  tenancies: [tenants.MU, tenants.MGU],
  isMenu: true,
  icon: <UserIcon />,
  name: AccountServicePath + USERS,
  title: "Потребители",
  permission: [permissions.canPreviewUsers, permissions.canPreviewDoctorants],
  subMenu: [Candidates, Students, ParticipantsPreparatory, Specialists, Doctorants],
};
